import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
import AlumnusActive from '@/components/newsActive/AlumnusActive';
import NewsDetail from '@/components/newsActive/NewsDetail';
import AlumniResources from '@/components/alumniResources/AlumniResources';
import AlumniDetails from '@/components/alumniResources/AlumniDetails';
import AlumniResourcesNew from '@/components/alumniResources/AlumniResourcesNew';
import AlumniDetailNew from '@/components/alumniResources/AlumniDetailNew';
import AlumniCard from '@/components/alumniCard/AlumniCard';
import HommieList from '@/components/hommie/List.vue';
import HommieDetail from '@/components/hommie/Detail.vue';
import WelfareDetails from '@/components/alumniCard/WelfareDetails';
import DonationIndex from '@/components/donation/DonationIndex';
import DonationMessage from '@/components/donation/DonationMessage';
import DonationList from '@/components/donation/DonationList';
import DonationDetail from '@/components/donation/DonationDetail';
import Ranking from '@/components/donation/Ranking';
import MyDonation from '@/components/donation/MyDonation';
import Receipt from '@/components/donation/Receipt';
import DonationSucc from '@/components/donation/DonationSucc';
import Certificate from '@/components/donation/Certificate';
import Appointment from '@/components/backSchool/Appointment';
import AppointmentCollective from '@/components/backSchool/AppointmentCollective';
import AppointmentSucc from '@/components/backSchool/AppointmentSucc';
import ActiveList from '@/components/active/ActiveList';
import ActiveDetails from '@/components/active/ActiveDetails';
import AlumniMeeting from '@/components/alumniMeeting/AlumniMeeting';
import MeetingDetails from '@/components/alumniMeeting/MeetingDetails';
import AlumniMembers from '@/components/alumniMeeting/AlumniMembers';
import MeetingMember from '@/components/alumniMeeting/MeetingMember';
import Mine from '@/components/mine/Mine';
import MySet from '@/components/mine/MySet';
import AlterTel from '@/components/mine/AlterTel';
import MyActive from '@/components/mine/MyActive';
import ActiveCode from '@/components/mine/ActiveCode';
import MyAlumni from '@/components/mine/MyAlumni';
import MyWelfareCard from '@/components/mine/MyWelfareCard';
import MyAlumniMeeting from '@/components/mine/MyAlumniMeeting';
import MyCard from '@/components/mine/MyCard';
import MyCardUpdate from '@/components/mine/MyCardUpdate';
import Login from '@/components/Login';
/* import EmailLogin from '@/components/EmailLogin'
import EmailRegister from '@/components/EmailRegister'
import EmailBindingPhone from '@/components/EmailBindingPhone' */
import WriteOffRegister from '@/components/WriteOffRegister';
import WriteOffRegisterSucc from '@/components/WriteOffRegisterSucc';
import WriteOffNotRegister from '@/components/WriteOffNotRegister';
//import SchoolCard from '@/components/SchoolCard'
import QuestionnaireList from '@/components/questionnaire/QuestionnaireList';
import QuestionnaireDetail from '@/components/questionnaire/QuestionnaireDetail';
import AchievementsList from '@/components/achievements/AchievementsList';
import AchievementsDetail from '@/components/achievements/AchievementsDetail';
import Cooperation from '@/components/achievements/Cooperation';
import CooperationDetail from '@/components/achievements/CooperationDetail';
import AddAchievements from '@/components/achievements/AddAchievements';
import AddCooperation from '@/components/achievements/AddCooperation';
import Service from '@/components/service/Service';
import GradeSelect from '@/components/service/GradeSelect';
import FoundPerson from '@/components/service/FoundPerson';
import FoundPersonDetail from '@/components/service/FoundPersonDetail';
import IssueFound from '@/components/service/IssueFound';
import Other from '@/components/service/Other';
import ServiceTips from '@/components/service/ServiceTips';
import MailList from '@/components/service/MailList';
import Activityqrcode from '@/components/writeOff/Activityqrcode';
import Welfareqrcode from '@/components/writeOff/Welfareqrcode';
import SiginIn from '@/components/siginIn/SiginIn';
import Blessing from '@/components/siginIn/Blessing';
import TakePhoto from '@/components/siginIn/TakePhoto';
import UserData from '@/components/register/UserData';
import AtSchoolData from '@/components/register/AtSchoolData';
import WorkData from '@/components/register/WorkData';

// import addCertification from '../../src/components/IdentitAuthentication/addCertification.vue'
import addCertification from '@/components/IdentitAuthentication/addCertification';
import completePersonInfo from '@/components/IdentitAuthentication/completePersonInfo';
import contactStaff from '@/components/IdentitAuthentication/contactStaff';
import failAuthentication from '@/components/IdentitAuthentication/failAuthentication';
import realName from '@/components/IdentitAuthentication/realName';
import completeInfo from '@/components/IdentitAuthentication/completeInfo';
import idSucess from '@/components/IdentitAuthentication/idSucess';
import UploadeTip from '@/components/uploadUserPhoto/uploadTip';
import UploadUserPhoto from '@/components/uploadUserPhoto/uploadUserPhoto';
import UploadSucc from '@/components/uploadUserPhoto/uploadSucc';
import UploadFail from '@/components/uploadUserPhoto/uploadFail';
import AlumniDetail from '@/components/alumniMeeting/AlumniDetail';
import AlumniHome from '@/components/alumniHome/AlumniHome';
import SchoolHistory from '@/components/alumniHome/SchoolHistory';
import CurrentLeader from '@/components/alumniHome/CurrentLeader';
import Constitution from '@/components/alumniHome/Constitution';
import HistoricalIntroduction from '@/components/alumniHome/HistoricalIntroduction';
import Character from '@/components/alumniHome/Character';
import CharacterDetails from '@/components/alumniHome/CharacterDetails';
import CharacterAlumniDetails from '@/components/alumniHome/CharacterAlumniDetails';
import Identification from '@/components/alumniHome/Identification';
import Campus from '@/components/alumniHome/Campus';
import Journal from '@/components/alumniHome/Journal';
import Clip from '@/components/alumniHome/Clip';
import SchoolRrunEnterprise from '@/components/alumniHome/SchoolRrunEnterprise';
import SchoolDetaile from '@/components/alumniHome/SchoolDetaile';
import Achievement from '@/components/alumniHome/Achievement';
import Dynamic from '@/components/alumniHome/Dynamic';
import DynamicDetails from '@/components/alumniHome/DynamicDetails';

import Map from '@/components/map/map';
Vue.use(Router);

/* export default new Router({
 */
const router = new Router({
  mode: 'history',
  // base: 'front', // 前缀名
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '校友登录注册',
        isTabber: false,
        hideHeader: true,
      },
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
      meta: {
        title: '导航',
      },
    },
    /* {
      path: '/emailLogin',
      name: 'EmailLogin',
      component: EmailLogin,
      meta: {
        title: '邮箱登录'
      }
    },
    {
      path: '/emailRegister',
      name: 'EmailRegister',
      component: EmailRegister,
      meta: {
        title: '邮箱注册'
      }
    },
    {
      path: '/emailBindingPhone',
      name: 'EmailBindingPhone',
      component: EmailBindingPhone,
      meta: {
        title: '邮箱绑定手机号'
      }
    }, */
    /*     {
          path: '/schoolCard',
          name: 'SchoolCard',
          component: SchoolCard,
          meta: {
            title: '学籍卡信息'
          }
        }, */

    {
      path: '/userData',
      name: 'UserData',
      component: UserData,
      meta: {
        title: '注册页面',
        isTabber: false,
      },
    },
    {
      path: '/atSchoolData',
      name: 'AtSchoolData',
      component: AtSchoolData,
      meta: {
        title: '注册页面',
        isTabber: false,
      },
    },
    {
      path: '/workData',
      name: 'WorkData',
      component: WorkData,
      meta: {
        title: '注册页面',
        isTabber: false,
      },
    },
    {
      path: '/writeOffRegister',
      name: 'WriteOffRegister',
      component: WriteOffRegister,
      meta: {
        title: '核销人员注册',
        isTabber: false,
      },
    },
    {
      path: '/writeOffRegisterSucc',
      name: 'WriteOffRegisterSucc',
      component: WriteOffRegisterSucc,
      meta: {
        title: '核销人员注册成功',
        isTabber: false,
      },
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index,
      meta: {
        title: '校友资源服务平台',
        isTabber: true,
      },
    },
    {
      path: '/alumnusActive',
      name: 'AlumnusActive',
      component: AlumnusActive,
      meta: {
        title: '消息通知',
        isTabber: false,
      },
    },
    {
      path: '/alumniResources',
      name: 'AlumniResources',
      component: AlumniResources,
      meta: {
        title: '校友资源',
        isTabber: false,
      },
    },
    {
      path: '/alumniDetails',
      name: 'AlumniDetails',
      component: AlumniDetails,
      meta: {
        title: '校友资源',
        isTabber: false,
      },
    },
    {
      path: '/alumniResourcesNew',
      name: 'AlumniResourcesNew',
      component: AlumniResourcesNew,
      meta: {
        title: '校友资源',
        isTabber: false,
      },
    },
    {
      path: '/alumniDetailNew',
      name: 'AlumniDetailNew',
      component: AlumniDetailNew,
      meta: {
        title: '资源详情',
        isTabber: false,
      },
    },
    {
      path: '/AlumniCard',
      name: 'AlumniCard',
      component: AlumniCard,
      meta: {
        title: '校友卡',
        isTabber: false,
      },
    },
    {
      path: '/hommieList',
      name: 'HommieList',
      component: HommieList,
      meta: {
        title: '校友之家',
        isTabber: false,
      },
    },
    {
      path: '/hommieDetail',
      name: 'HommieDetail',
      component: HommieDetail,
      meta: {
        title: '校友之家详情',
        isTabber: false,
      },
    },
    {
      path: '/welfareDetails',
      name: 'WelfareDetails',
      component: WelfareDetails,
      meta: {
        title: '校友福利',
        isTabber: false,
      },
    },
    {
      path: '/donationIndex',
      name: 'DonationIndex',
      component: DonationIndex,
      meta: {
        title: '爱心捐赠',
        // isTabber: false,
      },
    },
    {
      path: '/donationMessage',
      name: 'DonationMessage',
      component: DonationMessage,
      meta: {
        title: '捐赠寄语',
        // isTabber: false,
      },
    },
    {
      path: '/donationList',
      name: 'DonationList',
      component: DonationList,
      meta: {
        title: '项目列表',
        // isTabber: false,
      },
    },
    {
      path: '/donationDetail',
      name: 'DonationDetail',
      component: DonationDetail,
      meta: {
        title: '爱心捐赠',
        // isTabber: false,
      },
    },
    {
      path: '/ranking',
      name: 'Ranking',
      component: Ranking,
      meta: {
        title: '捐赠排行',
        // isTabber: false,
      },
    },
    {
      path: '/myDonation',
      name: 'MyDonation',
      component: MyDonation,
      meta: {
        title: '我的捐赠',
        // isTabber: false,
      },
    },
    {
      path: '/receipt',
      name: 'Receipt',
      component: Receipt,
      meta: {
        title: '爱心捐赠',
        isTabber: false,
      },
    },
    {
      path: '/donationSucc',
      name: 'DonationSucc',
      component: DonationSucc,
      meta: {
        title: '捐赠成功',
        isTabber: false,
      },
    },
    {
      path: '/certificate',
      name: 'Certificate',
      component: Certificate,
      meta: {
        title: '捐赠证书',
      },
    },
    {
      path: '/appointment',
      name: 'Appointment',
      component: Appointment,
      meta: {
        title: '返校预约',
        isTabber: false,
      },
    },
    {
      path: '/appointmentCollective',
      name: 'AppointmentCollective',
      component: AppointmentCollective,
      meta: {
        title: '集体返校预约',
        isTabber: false,
      },
    },
    {
      path: '/appointmentSucc',
      name: 'AppointmentSucc',
      component: AppointmentSucc,
      meta: {
        title: '预约成功',
        isTabber: false,
      },
    },
    {
      path: '/activeList',
      name: 'ActiveList',
      component: ActiveList,
      meta: {
        title: '校友活动',
        isTabber: false,
      },
    },
    {
      path: '/activeDetails',
      name: 'ActiveDetails',
      component: ActiveDetails,
      meta: {
        title: '活动详情',
        isTabber: false,
      },
    },
    {
      path: '/alumniMeeting',
      name: 'AlumniMeeting',
      component: AlumniMeeting,
      meta: {
        title: '各地校友',
        isTabber: false,
      },
    },
    {
      path: '/alumniDetail',
      name: 'AlumniDetail',
      component: AlumniDetail,
      meta: {
        title: '校友联络处',
        isTabber: false,
      },
    },
    {
      path: '/meetingDetails',
      name: 'MeetingDetails',
      component: MeetingDetails,
      meta: {
        title: '各地校友',
        isTabber: false,
      },
    },
    {
      path: '/alumniMembers',
      name: 'AlumniMembers',
      component: AlumniMembers,
      meta: {
        title: '校友成员',
        isTabber: false,
      },
    },

    {
      path: '/meetingMember',
      name: 'MeetingMember',
      component: MeetingMember,
      meta: {
        title: '分会成员',
        isTabber: false,
      },
    },
    {
      path: '/mine',
      name: 'Mine',
      component: Mine,
      meta: {
        title: '个人中心',
        isTabber: true,
      },
    },
    {
      path: '/mySet',
      name: 'MySet',
      component: MySet,
      meta: {
        title: '设置',
        isTabber: false,
      },
    },
    {
      path: '/alterTel',
      name: 'AlterTel',
      component: AlterTel,
      meta: {
        title: '修改手机号码',
        isTabber: false,
      },
    },
    {
      path: '/newsDetail',
      name: 'NewsDetail',
      component: NewsDetail,
      meta: {
        title: '消息详情',
        isTabber: false,
      },
    },
    {
      path: '/myActive',
      name: 'MyActive',
      component: MyActive,
      meta: {
        title: '我的活动',
        isTabber: false,
      },
    },
    {
      path: '/activeCode',
      name: 'ActiveCode',
      component: ActiveCode,
      meta: {
        title: '核销码',
        isTabber: false,
      },
    },
    {
      path: '/myAlumni',
      name: 'MyAlumni',
      component: MyAlumni,
      meta: {
        title: '我的好友',
        isTabber: false,
      },
    },
    {
      path: '/myWelfareCard',
      name: 'MyWelfareCard',
      component: MyWelfareCard,
      meta: {
        title: '劵包',
        isTabber: false,
      },
    },
    {
      path: '/myAlumniMeeting',
      name: 'MyAlumniMeeting',
      component: MyAlumniMeeting,
      meta: {
        title: '我的校友会',
        isTabber: false,
      },
    },
    {
      path: '/myCard',
      name: 'MyCard',
      component: MyCard,
      meta: {
        title: '我的名片',
        isTabber: false,
      },
    },
    {
      path: '/myCardUpdate',
      name: 'MyCardUpdate',
      component: MyCardUpdate,
      meta: {
        title: '完善个人信息',
        isTabber: false,
      },
    },
    {
      path: '/questionnaireList',
      name: 'QuestionnaireList',
      component: QuestionnaireList,
      meta: {
        title: '问卷调查',
        isTabber: false,
      },
    },
    {
      path: '/questionnaireDetail',
      name: 'QuestionnaireDetail',
      component: QuestionnaireDetail,
      meta: {
        title: '问卷调查',
        isTabber: false,
      },
    },
    {
      path: '/achievementsList',
      name: 'AchievementsList',
      component: AchievementsList,
      meta: {
        title: '成果转化',
        isTabber: false,
      },
    },
    {
      path: '/achievementsDetail',
      name: 'AchievementsDetail',
      component: AchievementsDetail,
      meta: {
        title: '科研成果详情',
        isTabber: false,
      },
    },
    {
      path: '/addAchievements',
      name: 'AddAchievements',
      component: AddAchievements,
      meta: {
        title: '发布成果',
        isTabber: false,
      },
    },
    {
      path: '/cooperation',
      name: 'Cooperation',
      component: Cooperation,
      meta: {
        title: '成果转化',
        isTabber: false,
      },
    },
    {
      path: '/cooperationDetail',
      name: 'CooperationDetail',
      component: CooperationDetail,
      meta: {
        title: '孵化合作详情',
        isTabber: false,
      },
    },
    {
      path: '/addCooperation',
      name: 'AddCooperation',
      component: AddCooperation,
      meta: {
        title: '发布需求',
        isTabber: false,
      },
    },
    {
      path: '/service',
      name: 'Service',
      component: Service,
      meta: {
        title: '服务大厅',
        isTabber: true,
      },
    },
    {
      path: '/alumniHome',
      name: 'AlumniHome',
      component: AlumniHome,
      meta: {
        title: '母校风采',
        isTabber: true,
      },
    },
    {
      path: '/schoolHistory',
      name: 'SchoolHistory',
      component: SchoolHistory,
      meta: {
        title: '学校简介',
        isTabber: false,
      },
    },
    {
      path: '/currentLeader',
      name: 'CurrentLeader',
      component: CurrentLeader,
      meta: {
        title: '现任领导',
        isTabber: false,
      },
    },
    {
      path: '/constitution',
      name: 'Constitution',
      component: Constitution,
      meta: {
        title: '学校章程',
        isTabber: false,
      },
    },
    {
      path: '/historicalIntroduction',
      name: 'HistoricalIntroduction',
      component: HistoricalIntroduction,
      meta: {
        title: '学校历史',
        isTabber: false,
      },
    },
    {
      path: '/character',
      name: 'Character',
      component: Character,
      meta: {
        title: '母校人物',
        isTabber: false,
      },
    },
    {
      path: '/characterDetails',
      name: 'CharacterDetails',
      component: CharacterDetails,
      meta: {
        title: '母校人物',
        isTabber: false,
      },
    },
    {
      path: '/characterAlumniDetails',
      name: 'CharacterAlumniDetails',
      component: CharacterAlumniDetails,
      meta: {
        title: '母校人物',
        isTabber: false,
      },
    },
    {
      path: '/identification',
      name: 'Identification',
      component: Identification,
      meta: {
        title: '学校标识',
        isTabber: false,
      },
    },
    {
      path: '/campus',
      name: 'Campus',
      component: Campus,
      meta: {
        title: '校园地图',
        isTabber: false,
      },
    },
    {
      path: '/journal',
      name: 'Journal',
      component: Journal,
      meta: {
        title: '电子期刊',
        isTabber: false,
      },
    },
    {
      path: '/clip',
      name: 'Clip',
      component: Clip,
      meta: {
        title: '母校映像',
        isTabber: false,
      },
    },
    {
      path: '/schoolRrunEnterprise',
      name: 'SchoolRrunEnterprise',
      component: SchoolRrunEnterprise,
      meta: {
        title: '交流合作',
        isTabber: false,
      },
    },
    {
      path: '/schoolDetaile',
      name: 'SchoolDetaile',
      component: SchoolDetaile,
      meta: {
        title: '合作交流',
        isTabber: false,
      },
    },
    {
      path: '/achievement',
      name: 'Achievement',
      component: Achievement,
      meta: {
        title: '科技成果',
        isTabber: false,
      },
    },
    {
      path: '/dynamic',
      name: 'Dynamic',
      component: Dynamic,
      meta: {
        title: '母校动态',
        isTabber: false,
      },
    },
    {
      path: '/dynamicDetails',
      name: 'DynamicDetails',
      component: DynamicDetails,
      meta: {
        title: '母校动态',
        isTabber: false,
      },
    },
    {
      path: '/gradeSelect',
      name: 'GradeSelect',
      component: GradeSelect,
      meta: {
        title: '成绩档案查询',
        isTabber: false,
      },
    },
    {
      path: '/foundPerson',
      name: 'FoundPerson',
      component: FoundPerson,
      meta: {
        title: '寻人找人',
        isTabber: false,
      },
    },
    {
      path: '/foundPersonDetail',
      name: 'FoundPersonDetail',
      component: FoundPersonDetail,
      meta: {
        title: '寻人找人',
        isTabber: false,
      },
    },
    {
      path: '/issueFound',
      name: 'IssueFound',
      component: IssueFound,
      meta: {
        title: '发布寻人找人',
        isTabber: false,
      },
    },
    {
      path: '/other',
      name: 'Other',
      component: Other,
      meta: {
        title: '其他',
        isTabber: false,
      },
    },
    {
      path: '/serviceTips',
      name: 'ServiceTips',
      component: ServiceTips,
      meta: {
        title: '办事指南',
        isTabber: false,
      },
    },
    {
      path: '/mailList',
      name: 'MailList',
      component: MailList,
      meta: {
        title: '通讯录',
        isTabber: false,
      },
    },
    {
      path: '/activityqrcode',
      name: 'Activityqrcode',
      component: Activityqrcode,
      meta: {
        title: '卡卷核销',
        isTabber: false,
      },
    },
    {
      path: '/welfareqrcode',
      name: 'Welfareqrcode',
      component: Welfareqrcode,
      meta: {
        title: '卡卷核销',
        isTabber: false,
      },
    },
    {
      path: '/writeOffNotRegister',
      name: 'WriteOffNotRegister',
      component: WriteOffNotRegister,
      meta: {
        title: '卡卷核销',
        isTabber: false,
      },
    },
    {
      path: '/siginIn',
      name: 'SiginIn',
      component: SiginIn,
      meta: {
        title: '签到',
        isTabber: false,
      },
    },
    {
      path: '/blessing',
      name: 'Blessing',
      component: Blessing,
      meta: {
        title: '祝福语',
        isTabber: false,
      },
    },
    {
      path: '/takePhoto',
      name: 'TakePhoto',
      component: TakePhoto,
      meta: {
        title: '与母校合影',
        isTabber: false,
      },
    },
    {
      path: '/addCertification',
      name: 'addCertification',
      component: addCertification,
      meta: {
        title: '沈阳工程学院校友服务平台',
        isTabber: false,
      },
    },
    {
      path: '/completePersonInfo',
      name: 'completePersonInfo',
      component: completePersonInfo,
      meta: {
        title: '补全个人信息',
        isTabber: false,
      },
    },
    {
      path: '/contactStaff',
      name: 'contactStaff',
      component: contactStaff,
      meta: {
        title: '人工认证信息',
        isTabber: false,
      },
    },
    {
      path: '/failAuthentication',
      name: 'failAuthentication',
      component: failAuthentication,
      meta: {
        title: '沈阳工程学院校友服务平台',
        isTabber: false,
      },
    },
    {
      path: '/realName',
      name: 'realName',
      component: realName,
      meta: {
        title: '实名认证',
        isTabber: false,
      },
    },
    {
      path: '/completeInfo',
      name: 'completeInfo',
      component: completeInfo,
      meta: {
        title: '补全个人信息',
        isTabber: false,
      },
    },
    {
      path: '/idSucess',
      name: 'idSucess',
      component: idSucess,
      meta: {
        title: '校友ID',
        isTabber: false,
      },
    },
    {
      path: '/uploadTip',
      name: 'uploadTip',
      component: UploadeTip,
      meta: {
        title: '沈阳工程学院校友资源服务平台',
        isTabber: false,
      },
    },
    {
      path: '/uploadUserPhoto',
      name: 'uploadUserPhoto',
      component: UploadUserPhoto,
      meta: {
        title: '沈阳工程学院校友资源服务平台',
        isTabber: false,
      },
    },
    {
      path: '/uploadSucc',
      name: 'uploadSucc',
      component: UploadSucc,
      meta: {
        title: '沈阳工程学院校友资源服务平台',
        isTabber: false,
      },
    },
    {
      path: '/uploadFail',
      name: 'uploadFail',
      component: UploadFail,
      meta: {
        title: '沈阳工程学院校友资源服务平台',
        isTabber: false,
      },
    },
  ],
});

// 防止重复点击导航，避免了到当前位置的冗余导航
const VueRouterPush = Router.prototype.push;
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

// 为路由配置导航卫士 next() 放行函数 next('')强转跳转

router.beforeEach((to, from, next) => {
  const openIdStr = window.localStorage.getItem('openid');
  // 核销人员的openid
  const writeOffOpenid = window.localStorage.getItem('writeOffOpenid');
  // 取实名认证状态，如果没有值跳转到login
  const realStatus = window.localStorage.getItem('realStatus');
  if (to.path === '/login') {
    next();
  } else if (to.path === '/writeOffRegister') {
    next();
  } else if (to.path === '/writeOffNotRegister') {
    next();
  } else if (to.path === '/siginIn') {
    next();
  } else if (to.path === '/blessing') {
    next();
  } else if (to.path === '/takePhoto') {
    next();
  } else if (to.path === '/activityqrcode' && !writeOffOpenid) {
    next('/writeOffNotRegister');
  } else if (to.path === '/welfareqrcode' && !writeOffOpenid) {
    next('/writeOffNotRegister');
  } else if (!openIdStr && !realStatus) {
    // next('/login')
    next();
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js